export default "__VITE_ASSET__dff09407__"